<div class="container">
  <form class="form__membro" [formGroup]="membroForm" novalidate="novalidate">
    <div class="alert alert-danger" *ngIf="mensagensErros.length > 0">
      <h3 id="msgRetorno">Opa! Alguma coisa não deu certo:</h3>
      <ul>
        <li *ngFor="let error of mensagensErros">{{ error }}</li>
      </ul>
    </div>

    <div class="dados__pessoais">
      <div class="row mb-3">
        <div class="col-12 column-mobile">
          <h3 class="lovers-font--bold font--size">Dados Pessoais</h3>
          <div class="container__edit">
            <p (click)="irParaAjuda()">
              <img class="edit__image" src="assets/images/icons/editDados.png" alt="" />
              Solicitar alteração de dados
            </p>
          </div>
        </div>
      </div>

      <div class="container__inputs_dados">
        <shared-input-lovers
          *ngIf="!updateStatus"
          [controlName]="'nome'"
          [label]="'Nome Completo'"
          [disabled]="!updateStatus"
        ></shared-input-lovers>
        <shared-input-lovers
          *ngIf="updateStatus"
          [controlName]="'nome'"
          [label]="'Nome Completo'"
          [disabled]="!updateStatus"
        ></shared-input-lovers>

        <shared-input-lovers
          [controlName]="'nomeSocial'"
          [label]="'Como prefere ser chamado'"
        ></shared-input-lovers>

        <shared-input-lovers
          [controlName]="'cpf'"
          [mask]="'000.000.000-00'"
          [label]="'CPF'"
          [disabled]="true"
        ></shared-input-lovers>

        <shared-input-lovers
          *ngIf="!updateStatus"
          [controlName]="'dataNascimento'"
          [label]="'Data de Nascimento aqui'"
          [disabled]="!updateStatus"
          [mask]="'00/00/0000'"
        ></shared-input-lovers>
        <shared-input-lovers
          *ngIf="updateStatus"
          [controlName]="'dataNascimento'"
          [label]="'Data de Nascimento'"
          [disabled]="updateStatus"
          [mask]="'00/00/0000'"
        ></shared-input-lovers>

        <shared-input-lovers
          [controlName]="'dataCadastro'"
          [label]="'Data de cadastro'"
          [mask]="'00/00/0000'"
          [disabled]="true"
        ></shared-input-lovers>

        <shared-dropdown-lovers
          [controlName]="'genero'"
          [valores]="valorGenero"
          [label]="'Gênero'"
        ></shared-dropdown-lovers>

      </div>
    </div>

    <div class="dados__complementares" *ngIf="membroForm.get('atributosForm')['controls']?.length > 0">
      <div class="row mb-3">
        <div class="col-12">
          <h3 class="lovers-font--bold font--size">Dados Complementares</h3>
        </div>
      </div>

      <div class="row mb-4">
        <div formArrayName="atributosForm" *ngFor="
            let atributo of membroForm.get('atributosForm')['controls'];
            let i = index;
            even as isEven
          " [ngClass]="
            isEven
              ? i > 1
                ? 'col-lg-6 col-md-6 col-sm-12 col-12 mt-2'
                : 'col-lg-6 col-md-6 col-sm-12 col-12'
              : 'col-lg-6 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2'
          ">
          <div class="lovers-input__container" [formGroupName]="i">
            <input class="campo__input" formControlName="valor" [type]="
                this.membroForm.get('atributosForm')['controls'][i].controls[
                  'tipo'
                ].value === 'string'
                  ? 'text'
                  : 'number'
              " [value]="
                this.membroForm.get('atributosForm')['controls'][i].controls[
                  'valor'
                ].value
              " placeholder=" " [ngClass]="{
                'invalid-input':
                  membroForm.get('dataNascimento').invalid &&
                  membroForm.get('dataNascimento').errors &&
                  (membroForm.get('dataNascimento').dirty ||
                    membroForm.get('dataNascimento').touched)
              }" />
            <label [for]="
                this.membroForm.get('atributosForm')['controls'][i].controls[
                  'id'
                ].value
              " class="campo__label">{{
              this.membroForm.get("atributosForm")["controls"][i].controls[
              "descricao"
              ].value
              }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="contatos">
      <div class="row mb-3">
        <div class="col-12">
          <h3 class="lovers-font--bold font--size">Contato</h3>
        </div>
      </div>

      <div class="row mb-4">
        <div
          class="d-flex flex-column gap-2 col-lg-6 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2"
        >
          <shared-input-lovers
            [controlName]="'telefone'"
            [mask]="'(00) 00000-0000'"
            [label]="'Telefone'"
            [habilitaIconeAlerta]="!membro.telefoneValidado"
            [mensagemGenerica]="
              !membro.telefoneValidado ? 'Telefone pendente de validação' : ''
            "
            [habilitaIconeCheck]="
              membro.telefoneValidado &&
              membro.telefone == membroForm.controls['telefone'].value
            "
          ></shared-input-lovers>

          <shared-button-lovers
            *ngIf="!membro.telefoneValidado"
            [variant]="'tertiary'"
            [label]="'Enviar código'"
            (onClick)="exibirPopupValidacaoDados(CAMPO_TELEFONE)"
          ></shared-button-lovers>

        </div>

        <div
          class="d-flex flex-column gap-2 col-lg-6 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2"
        >
          <shared-input-lovers
            [controlName]="'email'"
            [label]="'E-mail'"
            [habilitaIconeAlerta]="!membro.emailValidado"
            [mensagemGenerica]="
              !membro.emailValidado ? 'E-mail pendente de validação' : ''
            "
            [habilitaIconeCheck]="
              membro.emailValidado &&
              membro.email == membroForm.controls['email'].value
            "
          ></shared-input-lovers>

          <shared-button-lovers
            *ngIf="!membro.emailValidado"
            [variant]="'tertiary'"
            [label]="'Enviar código'"
            (onClick)="exibirPopupValidacaoDados(CAMPO_EMAIL)"
          ></shared-button-lovers>

        </div>
      </div>
    </div>

    <div class="Endereco">
      <div class="row mb-3">
        <div class="col-12">
          <h3 class="lovers-font--bold font--size">
            Endereço <span class="opcional">(Opcional)</span>
          </h3>
        </div>
      </div>

      <!-- Listagem de endereco -->
      <div class="row mb-3" *ngIf="enderecos?.length > 0">
        <div class="col-12" *ngFor="let item of enderecos">
          <app-cadastro-endereco [tipoAcao]="1" [exibir]="true" [idIndex]="item.idControle" [endereco]="item"
            (excluirEnderecoEvent)="this.removerEndereco($event)" (tornarEnderecoPrincipalEvent)="
              this.tornarEnderecoPrincipal($event)
            " (atualizarEnderecoEvent)="this.atualizarEndereco($event)"></app-cadastro-endereco>
        </div>
      </div>
      <!-- Novo Endereco-->
      <div class="row mb-4" *ngIf="!controleFormEndereco">
        <div class="col-12">
          <app-cadastro-endereco [tipoAcao]="0" [exibir]="!controleFormEndereco"
            (novoEnderecoEvent)="this.incluirNovoEndereco($event)" (cancelarFormEvent)="this.cancelarFormEndereco()">
          </app-cadastro-endereco>
        </div>
      </div>
      <!-- Botao para adicionar novo endereco -->
      <div class="botao__adicionar" *ngIf="controleFormEndereco">
        <shared-button-lovers
          [width]="width > 768 ? 343 : null"
          [variant]="'secondary'"
          [iconEsquerdoImagem]="'location.svg'"
          [label]="'Adicionar outro endereço'"
          (onClick)="controleFormEndereco = !controleFormEndereco"
        ></shared-button-lovers>
      </div>
    </div>

    <div class="senha">
      <div class="row mb-3">
        <div class="col-12">
          <h3 class="lovers-font--bold font--size">Senha</h3>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
          <shared-input-lovers
            [controlName]="'senha'"
            [label]="'Senha'"
            [type]="'password'"
            [exibirSenha]="true"
          ></shared-input-lovers>

          <div class="lovers-input__container mt-3">
            <app-validete-password [valuePassword]="membroForm.controls['senha'].value" />
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div
          class="col-lg-6 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2"
        >
          <shared-input-lovers
            [controlName]="'senhaConfirmacao'"
            [label]="'Confirmar senha'"
            [type]="'password'"
            [exibirSenha]="true"
          ></shared-input-lovers>
        </div>
      </div>
    </div>

    <div class="footer__form">
      <div class="row mt-4">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div>
            <shared-checkbox-lovers
              [controlName]="'aceiteTermo'"
              [labelAceite]="true"
              (change)="exibirPopupComunicacao($event)"
              (onTermosClick)="mostrarPopupTermos()"
              (onRegulamentosClick)="mostrarPopupRegulamento()"
            ></shared-checkbox-lovers>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center"
        >
          <shared-button-lovers
            [width]="343"
            [idButton]="'salvar'"
            [type]="'submit'"
            [variant]="'primary'"
            [label]="'Salvar'"
            [loading]="salvandoMembro"
            (onClick)="confirmValidFields()"
          ></shared-button-lovers>
        </div>
      </div>
    </div>
  </form>

  <div class="row mt-5">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
      <a class="font__terminar_relacao" (click)="exibirPopupTerminoConta()">
        <img class="opcao__icone mr-1" style="width: 15px; height: 13px"
          src="assets/images/icons/coracao_terminar_relacao.png" />
        Terminar a relação
      </a>
    </div>
  </div>
</div>

<!-- Modal Termino relacionamento -->
<lovers-popup [exibir]="exibirPopupTerminoContaOne" (onClose)="exibirPopupTerminoContaOne = false" tamanho="pequeno">
  <div class="popup__header">
    <p class="header__title">Poxa, {{ this.membro?.descricaoNivel }}...</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <h6 class="mb-0">Mas você disse que me amava! :(</h6>
      <h6>Tem certeza de que deseja terminar o nosso relacionamento?</h6>
    </div>
    <div class="lovers-checkbox__container">
      <input
        class="ui-checkbox"
        type="checkbox"
        name="confirmaExclusao"
        id="confirmaExclusao"
        [(ngModel)]="confirmaExclusao"
      />
      <label for="confirmaExclusao"
        >Estou ciente da perda de meus benefícios, como preço exclusivo, acúmulo
        e saldo de cacaus e pontos, entre outros.</label
      >
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex flex-column justify-content-center">
      <shared-button-lovers
        [variant]="'primary'"
        [label]="'Não'"
        (onClick)="cancelarExclucao()"
      ></shared-button-lovers>

      <shared-button-lovers
        [variant]="'secondary'"
        [label]="'Sim'"
        [disabled]="!confirmaExclusao"
        (onClick)="excluirCadastro()"
        [loading]="salvandoMembro"
      ></shared-button-lovers>

    </div>
  </div>
</lovers-popup>

<!-- Modal Comunicacao -->
<lovers-popup [exibir]="exibirModalComunicacao" (onClose)="fecharModalComunicacao()" tamanho="pequeno">
  <div class="popup__header">
    <p class="header__title">Hmm, tem certeza?</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <h6 class="mb-0">Em um relacionamento, comunicação é a base tudo.</h6>
      <h6>
        Tem certeza de que deseja parar de receber as novidades e deixar de ter
        acesso ao Preço Exclusivo, promoções e demais benefícios?
      </h6>
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex flex-column justify-content-center">
      <shared-button-lovers
        [variant]="'primary'"
        [label]="'Perder benefícios'"
        (onClick)="pararDeReceberComunicacao()"
      ></shared-button-lovers>
      <shared-button-lovers
        [variant]="'secondary'"
        [label]="'Voltar'"
        (onClick)="cancelarComunicacao()"
      ></shared-button-lovers>

    </div>
  </div>
</lovers-popup>

<!-- Modal Validação de Dados -->
<lovers-popup [exibir]="exibirModalValidacaoDados" (onClose)="exibirModalValidacaoDados = false" tamanho="pequeno">
  <div class="popup__header">
    <p class="header__title" style="text-transform: capitalize">
      {{ tituloModalGenerico }}
    </p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <h5 *ngIf="!descricaoModalGenerico" class="lovers-font--bold" style="color: black">
        Insira aqui o código enviado
      </h5>
      <h6 *ngIf="!descricaoModalGenerico">
        Enviamos o código para
        {{
        tituloModalGenerico == this.CAMPO_TELEFONE
        ? (membro.telefone | mask : "(00) 00000-0000")
        : membro.email
        }}
      </h6>
      <span *ngIf="descricaoModalGenerico" class="text-danger lovers-font--bold">{{ descricaoModalGenerico }}</span>
      <div *ngIf="!descricaoModalGenerico" class="row mb-4 w-100">
        <div class="col-2" *ngFor="let item of tamanhoInputValidacao; let i = index">
          <input type="text" pattern="[0-9]*" inputmode="numeric" [maxLength]="1" class="lovers-input__no_border"
            id="input_validacao_dados_{{ i }}" mask="0*" (keyup)="validarCodigo(i, tituloModalGenerico, $event)" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col-12 d-flex justify-content-center">
          <p class="mb-0">
            <span [innerHTML]="descricaoSegundosModalValidacaoDados"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex justify-content-center">
      <button [disabled]="exibirBotaoReenviar" class="lovers-button" *ngIf="!descricaoModalGenerico"
        (click)="exibirPopupValidacaoDados(tituloModalGenerico)">
        Reenviar
      </button>
    </div>
  </div>
</lovers-popup>
<!-- Modal generico -->
<lovers-popup [exibir]="exibirPopupGenerico" (onClose)="exibirPopupGenerico = false" tamanho="pequeno">
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <h6 class="mb-0"><span [innerHtml]="descricaoModalGenerico"></span></h6>
      <!-- <h6>{{descricaoPlusModalGenerico}}</h6> -->
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex justify-content-center">
      <button *ngIf="aceiteTermosBtn" class="lovers-button" [disabled]="salvandoMembro"
        [ngClass]="{ 'lovers--disabled': salvandoMembro }" (click)="aceiteTermosInit()">
        Aceitar
      </button>
      <button *ngIf="!aceiteTermosBtn" class="lovers-button" (click)="exibirPopupGenerico = false">
        {{ descricaoBotaoModalGenerico }}
      </button>

    </div>
  </div>
</lovers-popup>

<!-- Modal Confirma Aceite de Termos -->
<lovers-popup [exibir]="exibirModalAceiteInvalido" (onClose)="exibirModalAceiteInvalido = false" tamanho="pequeno">
  <div class="popup__header">
    <p class="header__title">Hmm, tem certeza?</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <!-- <h6 class="mb-0">Em um relacionamento, comunicação é a base tudo.</h6> -->
      <h6>
        Você não aceitou os termos e condições do Programa Cacau Lovers, desta
        forma não terá acesso ao Preço Exclusivo, promoções e demais benefícios.
        Deseja continuar?
      </h6>
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex justify-content-center">
      <button class="lovers-button mr-4" (click)="aceitarTermo()">
        Aceitar Termos
      </button>
      <button class="lovers-button" style="background-color: #ff9999" (click)="recusarTermo()">
        Não quero Benefícios
      </button>
    </div>
  </div>
</lovers-popup>

<!-- Modal Generico -->
<lovers-popup
  [exibir]="exibePopupGenerico"
  (onClose)="exibePopupGenerico = false"
  tamanho="grande"
>
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>
